/**
 * Rocket modals — hash + lygis detection
 * #stovykla | #stovykla-pradedantysis | #stovykla-patyres
 */
(function () {
  const HASH_MAP = {
    stovykla: { modal: "stovykla", lygis: "" },
    "stovykla-pradedantysis": { modal: "stovykla", lygis: "Pradedantysis" },
    "stovykla-patyres": { modal: "stovykla", lygis: "Patyręs" },
  };

  function getHashKey(hash) {
    return (hash || "").replace(/^#/, "").trim().toLowerCase();
  }

  function initRocketModals() {
    const root = document.querySelector("[data-rocket-modals]");
    if (!root) {
      return;
    }

    root.hidden = false;

    const modals = Array.from(root.querySelectorAll("[data-rocket-modal]"));
    if (!modals.length) {
      return;
    }

    const byName = Object.fromEntries(
      modals.map((el) => [el.getAttribute("data-rocket-modal"), el])
    );

    let lastFocus = null;
    let activeModal = null;
    let closeTimer = null;

    const clearCloseTimer = () => {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
    };

    const resetModal = (modal) => {
      modal.classList.remove("is-success");

      const success = modal.querySelector("[data-rocket-modal-success]");
      if (success) {
        success.hidden = true;
      }

      const body = modal.querySelector("[data-rocket-modal-body]");
      if (body) {
        body.hidden = false;
      }

      const header = modal.querySelector(".rocket-modal__header");
      if (header) {
        header.hidden = false;
      }

      const form = modal.querySelector(".wpcf7 form");
      if (form) {
        form.classList.remove("sent", "invalid", "failed", "submitting");
        form.reset();

        const response = form.querySelector(".wpcf7-response-output");
        if (response) {
          response.textContent = "";
          response.setAttribute("aria-hidden", "true");
        }
      }
    };

    const showSuccess = (modal) => {
      modal.classList.add("is-success");

      const header = modal.querySelector(".rocket-modal__header");
      if (header) {
        header.hidden = true;
      }

      const body = modal.querySelector("[data-rocket-modal-body]");
      if (body) {
        body.hidden = true;
      }

      const success = modal.querySelector("[data-rocket-modal-success]");
      if (success) {
        success.hidden = false;
      }
    };

    const setLygis = (modal, lygis) => {
      const input = modal.querySelector("#rocket-form-lygis");
      if (input) {
        input.value = lygis || "Stovykla";
      }

      const badge = modal.querySelector("[data-rocket-modal-level]");
      if (!badge) {
        return;
      }

      if (lygis) {
        badge.textContent = lygis;
        badge.hidden = false;
      } else {
        badge.textContent = "";
        badge.hidden = true;
      }
    };

    const openModal = (name, lygis = "") => {
      const modal = byName[name];
      if (!modal) {
        return;
      }

      if (activeModal && activeModal !== modal) {
        closeModal(activeModal, false);
      }

      clearCloseTimer();
      resetModal(modal);

      lastFocus = document.activeElement;
      activeModal = modal;
      modal.hidden = false;
      document.body.classList.add("rocket-modal-open");
      setLygis(modal, lygis);

      const focusTarget =
        modal.querySelector("input:not([type='hidden']), textarea, button") ||
        modal.querySelector("[data-rocket-modal-close]");
      if (focusTarget) {
        window.setTimeout(() => focusTarget.focus(), 30);
      }
    };

    const closeModal = (modal, clearHash = true) => {
      const target = modal || activeModal;
      if (!target) {
        return;
      }

      clearCloseTimer();
      target.hidden = true;
      resetModal(target);

      if (activeModal === target) {
        activeModal = null;
      }

      if (!activeModal) {
        document.body.classList.remove("rocket-modal-open");
      }

      if (clearHash) {
        const key = getHashKey(window.location.hash);
        if (HASH_MAP[key]) {
          const url = window.location.pathname + window.location.search;
          window.history.replaceState(null, "", url);
        }
      }

      if (lastFocus && typeof lastFocus.focus === "function") {
        lastFocus.focus();
      }
    };

    const openFromHash = () => {
      const key = getHashKey(window.location.hash);
      const config = HASH_MAP[key];
      if (!config) {
        return;
      }
      openModal(config.modal, config.lygis);
    };

    const resolveFromHref = (href) => {
      if (!href) {
        return null;
      }

      try {
        const url = new URL(href, window.location.origin);
        if (url.origin !== window.location.origin && !href.startsWith("#")) {
          return null;
        }
        const key = getHashKey(url.hash);
        return HASH_MAP[key] || null;
      } catch (error) {
        return null;
      }
    };

    document.addEventListener("click", (event) => {
      const closeBtn = event.target.closest("[data-rocket-modal-close]");
      if (closeBtn) {
        event.preventDefault();
        closeModal(closeBtn.closest("[data-rocket-modal]") || activeModal);
        return;
      }

      const trigger = event.target.closest("[data-rocket-modal-open]");
      if (trigger) {
        event.preventDefault();
        const name = trigger.getAttribute("data-rocket-modal-open");
        const lygis = trigger.getAttribute("data-rocket-lygis") || "";
        openModal(name, lygis);
        return;
      }

      const link = event.target.closest("a[href]");
      if (!link) {
        return;
      }

      const config = resolveFromHref(link.getAttribute("href"));
      if (!config) {
        return;
      }

      event.preventDefault();
      openModal(config.modal, config.lygis);

      const hashKey = Object.entries(HASH_MAP).find(
        ([, value]) => value.modal === config.modal && value.lygis === config.lygis
      )?.[0];
      if (hashKey) {
        window.history.replaceState(null, "", `#${hashKey}`);
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && activeModal) {
        closeModal(activeModal);
      }
    });

    window.addEventListener("hashchange", openFromHash);
    openFromHash();

    document.addEventListener(
      "wpcf7mailsent",
      (event) => {
        const modal = event.target.closest("[data-rocket-modal]");
        if (!modal) {
          return;
        }

        showSuccess(modal);
        clearCloseTimer();
        closeTimer = window.setTimeout(() => closeModal(modal), 3000);
      },
      false
    );
  }

  document.addEventListener("DOMContentLoaded", initRocketModals);
})();
